module.exports = __webpack_public_path__ + "static/media/acai_berry_tonic.e2abd9e0.png";